import React from 'react';
import {Form, Formik} from 'formik';
import s from './MainLessons.module.css';
import {QuestionType} from '../../../types/TypesEducation';
import TaskQuestionElement from './TaskQuestionElement';
import VeryLightGreenButton from '../../../Components/Buttons/VeryLightGreenButton';
import {useDispatch, useSelector} from 'react-redux';
import {getStudyComplete} from '../../../redux/education_Reducer';

type Props = {
	questions: QuestionType[] | null;
	text_questions: string;
	text_set_lesson: string;
	lessonId: number;
};
const TestLessonForm: React.FC<Props> = ({
	questions,
	lessonId,
	text_questions,
	text_set_lesson,
}) => {
	const dispatch: any = useDispatch();
	const studyComplete = useSelector(() => getStudyComplete);

	const initialValues = {
		data: [],
	};

	return (
		<Formik
			enableReinitialize
			initialValues={initialValues}
			onSubmit={(values) => {
				dispatch(studyComplete(values, lessonId));
			}}
		>
			{({values, handleSubmit, setFieldValue}) => {
				return (
					<Form>
						<div className={s.tasksContainer}>
							<div className={`${s.planPlan} page__plan plan`}>
								<div className="plan__title">{text_questions}</div>
							</div>
							<div
								className={`${s.sliderContainer} page__marketing-slider slider-marketing`}
							>
								<div className={`${s.sliderWrapper} slider-marketing__wrapper`}>
									{questions?.map((question: QuestionType, index: number) => {
										return (
											<div
												key={`questiontitle${question?.question_id ?? +Math.random()}`}
											>
												<TaskQuestionElement
													title={question.title}
													values={values}
													answers={question?.answers}
													index={index}
													questionId={question?.question_id}
													setFieldValue={setFieldValue}
												/>
											</div>
										);
									})}
								</div>
							</div>
						</div>
						<div className={s.buttonWrapper}>
							<VeryLightGreenButton
								text={text_set_lesson}
								type={'button'}
								onClick={handleSubmit}
							/>
						</div>
					</Form>
				);
			}}
		</Formik>
	);
};

export default TestLessonForm;
